
import Msg from 'vux/src/components/msg/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import WxHeader from './Header'
import WxFooter from './Footer'

export default {
components: {
WxHeader,
WxFooter,
Msg,
Divider,
XButton
},
data () {
return {
title : '正在加载...',
description: '',
icon: 'waiting'
}
},
created(){
this.force_get_login_data();
},
methods: {
force_get_login_data(){

let _self = this;
let login_data = this.get_login_session_data();
if(!login_data){
_self.changeIcon ('warn');
_self.title = '未登陆，请重新登陆';
_self.description = '';
return
}
let api_url = this.server_api_url+'service=get_login_data'
this.$axios({
method:'post',
url:api_url,
data:this.qs.stringify({//这里是发送给后台的数据
member_id:login_data.member_id,
openid:login_data.openid
})
}).then((response) =>{          //这里使用了ES6的语法


let data_arr = response.data;
if(data_arr.status == '1'){

if(data_arr.data.disabled != login_data.disabled){
_self.set_login_session_data(data_arr.data);
_self.set_access_token(data_arr.access_token);
}
if(data_arr.data.disabled == '-1'){
_self.changeIcon ('warn');
_self.title = '等待审核中，通过后才能登陆';
_self.description = '审核通过后我们会短信通知您，谢谢!';
return
}else if(data_arr.data.disabled == '1'){
_self.changeIcon ('warn');
_self.title = '您的账号已被禁用！';
_self.description = '若有疑问请联系物业管理处!';
return
}else{





if(login_data.house_nums <= 0){
_self.changeIcon ('warn');
_self.title = '您不是业主或暂无可选择的房间!';
_self.description = '若有疑问请联系物业管理处!';
return
}else if(login_data.house_nums > 1){
_self.$router.push({path: '/HouseMy'});
}else{
_self.$router.push({path: '/MemberCenter'});
}
}
}else{
_self.changeIcon ('warn');
_self.title = '操作异常，请重新刷新试试';
_self.description = data_arr.msg;
}
}).catch((response) =>{
console.log(response)       
})
},

changeIcon (icon_state) {
if (icon_state == 'success') {
this.icon = 'success'
return
}
if (icon_state ==='warn') {
this.icon = 'warn'
return
}
if (icon_state == 'info') {
this.icon = 'info'
return
}
if (icon_state == 'waiting') {
this.icon = 'waiting'
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/MemberCheck.vue